
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {ModalModule} from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { ChatComponent } from './chat.component';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ChatInternalComponent } from './chat_internal.component'
import { Select2Module } from 'ng2-select2';

@NgModule({
    imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        BrowserModule,
        ToastrModule.forRoot(),
        ModalModule.forRoot(),
        TooltipModule.forRoot(),
        Select2Module
    ],

    declarations: [
        ChatComponent,
        ChatInternalComponent
    ],
    exports: [ChatComponent],

    providers: []
})

export class ChatModule {
}



// WEBPACK FOOTER //
// G:/3csoft/client-final/src/app/pages/admin/icontact/chat/chat.module.ts